import { pluginKey } from './';
export var applyChange = function (tr) {
    return tr.setMeta(pluginKey, { changed: true });
};
//# sourceMappingURL=transforms.js.map